import { render, staticRenderFns } from "./ebp-multiselect.vue?vue&type=template&id=628e7476"
import script from "./ebp-multiselect.vue?vue&type=script&lang=js"
export * from "./ebp-multiselect.vue?vue&type=script&lang=js"
import style0 from "./ebp-multiselect.vue?vue&type=style&index=0&id=628e7476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports